import { PriceCategory } from 'types/sponsored-products';

export const getPriceType = (
  productPriceCategory: PriceCategory,
  isPreviousPrice: boolean,
): 'best' | 'discount' | 'default' => {
  if (productPriceCategory === 'BPR') {
    return 'best';
  }

  if (isPreviousPrice) {
    return 'discount';
  }

  return 'default';
};
